<template>
  <footer class="site-footer">
    <div class="content-max-width">
      <div class="top flex">
        <div class="button giant">
          <span> Get in touch </span>
          <span class="flex">
            <a :href="contactlink.url">click here <img src="/images/icons/arrow-right.svg" alt="" /></a>
          </span>
        </div>
        <img
            class="totop"
            src="/images/icons/gotop.svg"
            alt=""
            @click="goToTop"
        />
      </div>
      <div class="bottom flex">
        <div class="copyright">
          <p>Copyright © 2020 Canam Group Ltd</p>
          <p>Web design by <a href="https://brownpaperbag.co.nz" target="_blank">Brownpaperbag</a></p>
        </div>
        <div class="socials flex">
          <a v-for="(item, index) of social" :key="index" :href="item.url">
            <img :src="item.icon" alt="" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: ["social","contactlink"],
  methods: {
      goToTop() {
          window.scrollTo(0,0);
      },

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue